<template>
  <portal to="content-header-right">
    <div class="panel-toolbar">
      <button
        type="button"
        class="panel-toolbar__eye"
        :aria-label="$t('influencer_panel.toggle_money')"
        :title="$t('influencer_panel.toggle_money')"
        @click="toggleMoney"
      >
        <feather-icon :icon="moneyHidden ? 'EyeOffIcon' : 'EyeIcon'" size="16" />
      </button>

      <b-form-select
        v-if="showPeriod"
        :value="period"
        :options="periodOptions"
        size="sm"
        class="panel-toolbar__period"
        :aria-label="$t('influencer_panel.period')"
        @change="$emit('update:period', $event)"
      />
    </div>
  </portal>
</template>

<script>
import { BFormSelect } from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import { PERIODS } from '../panel'

/**
 * Acoes do cabecalho da tela: o olho de ocultar valores e o seletor de periodo.
 *
 * Vai por portal para dentro do `AppBreadcrumb`, que e quem desenha o titulo e a trilha
 * — assim as acoes ficam na mesma linha do h1, como no design, sem cada tela ter de
 * redesenhar o cabecalho.
 */
export default {
  name: 'PanelToolbar',
  components: { BFormSelect },
  props: {
    period: { type: String, default: 'current_month' },
    showPeriod: { type: Boolean, default: false },
  },
  computed: {
    ...mapGetters('moneyVisibility', ['moneyHidden']),
    periodOptions() {
      return PERIODS.map(value => ({ value, text: this.$t(`influencer_panel.period_${value}`) }))
    },
  },
  methods: {
    toggleMoney() {
      this.$store.dispatch('moneyVisibility/toggleMoneyHidden')
    },
  },
}
</script>

<style scoped>
.panel-toolbar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.panel-toolbar__eye {
  width: 38px;
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--input-border);
  border-radius: var(--radius);
  background: var(--surface-card);
  color: var(--text-body);
  cursor: pointer;
  transition: var(--transition-btn);
}

.panel-toolbar__eye:hover {
  border-color: var(--primary);
  color: var(--primary);
}

.panel-toolbar__period {
  width: auto;
  min-width: 160px;
}
</style>
